export const cn = {
    register_or_login: '注册/登录',
    unlock_pro_capabilities_and_history: '解锁专业功能和历史记录',
    other_login_type: '其他登录方式',
    cn: {
        wechat_login_tab: '微信扫码',
        sms_login_tab: '手机验证',
        login_button: '注册/登录',
    },
    us: {
        email_sign_up: '或者使用您的企业邮箱注册',
        sign_up: '注册',
        already_have_account: '已经有账户了？',
        login: '登录',
        not_have_account: '还没有账户？',
        register: '注册',
        terms_of_service: '我已阅读并同意 PatSnap 的 <a ref="nofollow" target="_blank" class="text-eureka-600" href="{termsOfServiceUrl}">服务条款</a> 和 <a ref="nofollow" target="_blank" class="text-eureka-600" href="https://www.patsnap.com/legal/privacy-policy/">隐私政策</a>',
        register_success: {
            title: '注册成功，请验证您的电子邮件。',
            content: '要使用 Eureka，请点击我们发送到 <span class="font-semibold">{ email }</span> 的电子邮件中的验证按钮。',
            content2: '这有助于保护您的账户安全。',
            content3: '您应该很快就会收到它。别忘了检查邮件文件夹。',
        },
        tenant: {
            title: '请选择一个企业',
            individual: '以个人身份登录',
            domain_restrict: '域名限制',
            ip_restrict: 'IP限制',
            sso_restrict: 'SSO限制',
            disabled: {
                30177: '您的邮箱未设置或未认证，请去用户设置-个人信息中认证邮箱',
                30145: '您所在的组织要求您使用企业邮箱访问智慧芽，请通过邮箱登录。',
                30108: '请在指定的IP范围内访问该产品。<br>您所在的组织希望您在指定地点（如办公室）访问我们的产品。',
                30301: '请在指定的IP范围内访问该产品。<br>您所在的组织希望您在指定地点（如办公室）访问我们的产品。',
                30303: '请在指定的IP范围内访问该产品。<br>您所在的组织希望您在指定地点（如办公室）访问我们的产品。',
                30173: '请通过钉钉登录',
                30175: '请通过飞书登录',
                30174: '请通过企业微信登录',
                30176: '请通过内部认证服务器登录',
            },
        },
        linkedin: {
            title: '通过领英登录',
        },
        microsoft: {
            title: '通过Microsoft登录',
        },
        register_email: {
            email_placeholder: '请输入企业邮箱',
            password_placeholder: '请输入密码',
            password: {
                required: '请输入密码',
                invalid: '密码必须为8-32个字符，并包含一个数字。',
            },
            email: {
                required: '请输入邮箱',
                invalid: '请输入有效的电子邮件地址',
                personalEmail: '请输入您的企业邮箱',
                exists: '邮箱地址已经存在。',
                inBlacklist: '请输入您的企业邮箱',
            },
            server: {
                busy: '服务繁忙，请稍后再试。',
            },
        },
        google_login: {
            title: '通过谷歌登录',
            error_code: {
                31620: '认证信息过期，请重试。',
                31621: '您的账号还未认证，请到您的邮箱点击激活。如未收到邮件，点击 <a class="login-with-google-error-target" data-code="30111" target="_blank" href="{ accountUrl }/public/?{ paramsUrl }#/resendActive?email={ userEmail }">这里</a>。',
                30141: '账号被禁用',
                30102: '账号被禁用',
                30103: '用户名密码错误',
                30101: '用户名密码错误',
                30113: '用户名密码错误',
                180102: '用户名密码错误',
                30129: '邮箱已经存在。',
                30401: '您已登出，请重新登录',
                30407: '会话已超时，请重新登录',
                180203: '验证码错误',
                unknown: '发生未知错误，需要帮助请联系我们',
            },
        },
        confirm_password: {
            message: '您的电子邮件：{email}',
            title: '验证您的账户',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPlaceholder: '请输入您的 PatSnap 账户密码',
            inputErrorMessage: '密码必须为8-32个字符，并包含一个数字。',
        },
        free_sign_up: '免费注册',
    },
}

export const en = {
    register_or_login: 'Register/Login',
    unlock_pro_capabilities_and_history: 'Unlock Pro Capabilities and History',
    other_login_type: 'Other login methods',
    cn: {
        wechat_login_tab: 'WeChat Scan',
        sms_login_tab: 'Phone Verify',
        login_button: 'Register/Login',
    },
    us: {
        email_sign_up: 'Or your business email sign up',
        sign_up: 'Sign Up',
        already_have_account: 'Already have an account?',
        login: 'Login',
        not_have_account: 'Don\'t have an account?',
        register: 'Register',
        terms_of_service: 'I have read and agreed to PatSnap\'s <a ref="nofollow" target="_blank" class="text-eureka-600" href="{termsOfServiceUrl}">Terms of Service</a> and <a ref="nofollow" target="_blank" class="text-eureka-600" href="https://www.patsnap.com/legal/privacy-policy/">Privacy Policy</a>',
        register_success: {
            title: 'Great, Please verify your email.',
            content: 'To use Eureka, click the verification button in the email we sent to <span class="font-semibold">{ email }</span>.',
            content2: 'This helps keep your account secure.',
            content3: 'You should receive it shortly. Don\'t forget to check your spam folder.',
        },
        tenant: {
            title: 'Please select an Organization',
            individual: 'Sign in as an individual',
            domain_restrict: 'Domain Restrictions',
            ip_restrict: 'IP Restrictions',
            sso_restrict: 'SSO Restrictions',
            disabled: {
                30177: 'Sorry, your email is null or not verified, please go to Account - Personal Information to verify.',
                30145: 'Your organization requires you to use your business email address to access PatSnap. Please login via email.',
                30108: 'Please access the product within the specified IP range.<br>For security reasons, your company has limited access to our products within specified locations e.g.designated offices.',
                30301: 'Please access the product within the specified IP range.<br>For security reasons, your company has limited access to our products within specified locations e.g.designated offices.',
                30303: 'Please access the product within the specified IP range.<br>For security reasons, your company has limited access to our products within specified locations e.g.designated offices.',
                30173: 'Your administrator requires you to login via DingTalk to access PatSnap.',
                30175: 'Your administrator requires you to login via Feishu to access PatSnap.',
                30174: 'Your administrator requires you to login via WeCom to access PatSnap.',
                30176: 'Please login via Internal Authentication Server',
            },
        },
        linkedin: {
            title: 'Sign in with LinkedIn',
        },
        microsoft: {
            title: 'Sign in with Microsoft',
        },
        register_email: {
            email_placeholder: 'Enter your business email',
            password_placeholder: 'Enter your password',
            password: {
                required: 'Please input the password',
                invalid: 'Password must be between 8-32 characters and include a number.',
            },
            email: {
                required: 'Please input the email',
                invalid: 'Please enter a valid email address',
                personalEmail: 'Please enter your business email',
                exists: 'Email address already exists.',
                inBlacklist: 'Please enter your business email',
            },
            server: {
                busy: 'The Service is busy, please try again later.',
            },
        },
        google_login: {
            title: 'Sign in with Google',
            error_code: {
                31620: 'The authentication information has expired. Please try again.',
                31621: 'Your account has not been authenticated. Please activate your account from your email. If you have not received your email, click <a class="login-with-google-error-target" data-code="30111" target="_blank" href="{ accountUrl }/public/?{ paramsUrl }#/resendActive?email={ userEmail }">here</a>.',
                30141:
                'Your account has been disabled due to illegal operations. If you have any questions about this, please contact your account manager.',
                30102:
                'Your account has been disabled due to illegal operations. If you have any questions about this, please contact your account manager.',
                30103: 'Incorrect username or password',
                30101: 'Incorrect username or password',
                30113: 'Incorrect username or password',
                180102: 'Incorrect username or password',
                30129: 'Email address already exists.',
                30401: 'You have been logged out.',
                30407: 'Your session has expired, please login again.',
                180203: 'Incorrect verification code.',
                unknown: 'An unknown error has occurred. Please contact us if you need any help.',
            },
        },
        confirm_password: {
            message: 'Your Email: {email}',
            title: 'Certify Your Account',
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPlaceholder: 'Enter your PatSnap account password',
            inputErrorMessage: 'Password must be between 8-32 characters and include a number.',
        },
        free_sign_up: 'Free Sign Up',
    },
}

export const jp = {
    register_or_login: '登録/ログイン',
    unlock_pro_capabilities_and_history: 'プロ機能と履歴のロックを解除',
    other_login_type: 'その他のログイン方法',
    cn: {
        wechat_login_tab: 'WeChatスキャン',
        sms_login_tab: '電話認証',
        login_button: '登録/ログイン',
    },
    us: {
        email_sign_up: 'またはビジネス用メールでサインアップ',
        sign_up: 'サインアップ',
        already_have_account: 'すでにアカウントをお持ちですか？',
        login: 'ログイン',
        not_have_account: 'アカウントをお持ちでない場合',
        register: '注册',
        terms_of_service: 'PatSnapの<a ref="nofollow" target="_blank" class="text-eureka-600" href="{termsOfServiceUrl}">利用規約</a>および<a ref="nofollow" target="_blank" class="text-eureka-600" href="https://www.patsnap.com/legal/privacy-policy/">プライバシーポリシー</a>を読み、同意しました。',
        register_success: {
            title: '素晴らしい、メールを確認してください。',
            content: 'Eurekaを使用するには、<span class="font-semibold">{ email }</span> に送信されたメールの確認ボタンをクリックしてください。',
            content2: 'これにより、アカウントのセキュリティが保たれます。',
            content3: '間もなく受信するはずです。迷惑メールフォルダーを忘れずに確認してください。',
        },
        tenant: {
            title: '企業を選択してください',
            individual: '個人アカウント',
            domain_restrict: 'ドメイン制限',
            ip_restrict: 'IP 制限',
            sso_restrict: 'SSO の制限',
            disabled: {
                30177: 'あなたのメールアドレスは検証されていません。アカウント-個人情報に移動してメール検証を完了してください。',
                30145: 'ご所属の組織では、ビジネス用メールアドレスを用いてPatSnapにアクセスすることを要求されていますため、メールアドレスでログインしてください。',
                30108: '指定されたIP範囲内で本製品にアクセスしてください。<br>御社はセキュリティ上の理由により、 弊社の製品にアクセスする場所を限定しています（ 例えば、 御社のオフィス）。',
                30301: '指定されたIP範囲内で本製品にアクセスしてください。<br>御社はセキュリティ上の理由により、 弊社の製品にアクセスする場所を限定しています（ 例えば、 御社のオフィス）。',
                30303: '指定されたIP範囲内で本製品にアクセスしてください。<br>御社はセキュリティ上の理由により、 弊社の製品にアクセスする場所を限定しています（ 例えば、 御社のオフィス）。',
                30173: 'DingTalk方式でログインしてください',
                30175: 'Feishu方式でログインしてください',
                30174: 'WeCom方式でログインしてください',
                30176: 'SSO方式でログインしてください',
            },
        },
        linkedin: {
            title: 'LinkedInでサインイン',
        },
        register_email: {
            email_placeholder: 'ビジネスメールアドレスを入力してください',
            password_placeholder: 'パスワードを入力してください',
            password: {
                required: 'パスワードを入力してください',
                invalid: 'パスワードは8〜32文字で、数字を含めてください。',
            },
            email: {
                required: 'メールアドレスを入力してください',
                invalid: '有効なメールアドレスを入力してください',
                personalEmail: 'ビジネス用メールアドレスを入力してください',
                exists: 'メールアドレスはすでに存在しています。',
                inBlacklist: 'ビジネス用メールアドレスを入力してください',
            },
            server: {
                busy: 'サービスが混雑しています。後でもう一度お試しください。',
            },
        },
        google_login: {
            title: 'Googleでサインイン',
            error_code: {
                31620: '認証情報の有効期限が切れています。もう一度お試しください。',
                31621: 'このアカウントはまだ認証されていません。弊社からのメールに記載されているリンクをクリックして、アカウントを有効にしてください。メールが見つからない場合には、<a class="login-with-google-error-target" data-code="30111" target="_blank" href="{ accountUrl }/public/?{ paramsUrl }#/resendActive?email={ userEmail }">をクリックしてください。</a>.',
                30141: 'アカウントがブロックされています',
                30102: 'アカウントがブロックされています',
                30103: 'パスワードが間違っています。',
                30101: 'パスワードが間違っています。',
                30113: 'パスワードが間違っています。',
                180102: 'パスワードが間違っています。',
                30129: 'このメールアドレスは登録済みです。',
                30401: 'ログアウトされましたので、新たにご登録ください。',
                30407: 'セッションがタイムアウトしました。再度ログインしてご利用ください。',
                180203: '認証コードが間違っています',
                unknown: '不明なエラーが発生しました。Patsnapカスタマーサービスまでご連絡ください。',
            },
        },
        confirm_password: {
            message: 'あなたのメール: {email}',
            title: 'アカウントを認証してください',
            confirmButtonText: 'OK',
            cancelButtonText: 'キャンセル',
            inputPlaceholder: 'PatSnapアカウントのパスワードを入力してください',
            inputErrorMessage: 'パスワードは8〜32文字で、数字を含めてください。',
        },
        free_sign_up: '無料登録',
    },
}

export const tw = {
    register_or_login: '註冊/登錄',
    unlock_pro_capabilities_and_history: '解鎖專業功能和歷史記錄',
    other_login_type: '其他登錄方式',
    cn: {
        wechat_login_tab: '微信掃碼',
        sms_login_tab: '手機驗證',
        login_button: '註冊/登錄',
    },
    us: {
        email_sign_up: '或使用您的商務郵箱註冊',
        sign_up: '註冊',
        already_have_account: '已經有賬戶？',
        login: '登錄',
        not_have_account: '還沒有賬戶？',
        register: '註冊',
        terms_of_service: '我已閱讀並同意 PatSnap 的<a ref="nofollow" target="_blank" class="text-eureka-600" href="{termsOfServiceUrl}">服務條款</a>和<a ref="nofollow" target="_blank" class="text-eureka-600" href="https://www.patsnap.com/legal/privacy-policy/">隱私政策</a>',
        register_success: {
            title: '太棒了，請驗證您的郵箱。',
            content: '要使用 Eureka，請點擊我們發送到 <span class="font-semibold">{ email }</span> 的郵件中的驗證按鈕。',
            content2: '這有助於保護您的賬戶安全。',
            content3: '您應該很快會收到。別忘了檢查垃圾郵件夾。',
        },
        tenant: {
            title: '請選擇一個企業',
            individual: '以個人身份登錄',
            domain_restrict: '域名限制',
            ip_restrict: 'IP限制',
            sso_restrict: 'SSO限制',
            disabled: {
                30177: '您的郵箱未設定或未認證，請去用戶設置-個人資訊中認證郵箱',
                30145: '您所在的組織要求您使用商務郵箱訪問智慧芽，請通過郵箱登錄。',
                30108: '請在指定的IP範圍內訪問該產品。<br>您所在的組織希望您在指定地點（ 如辦公室） 訪問我們的產品。',
                30301: '請在指定的IP範圍內訪問該產品。<br>您所在的組織希望您在指定地點（ 如辦公室） 訪問我們的產品。',
                30303: '請在指定的IP範圍內訪問該產品。<br>您所在的組織希望您在指定地點（ 如辦公室） 訪問我們的產品。',
                30173: '請通過釘釘登錄',
                30175: '請通過飛書登錄',
                30174: '請通過企業微信登錄',
                30176: '請通過內部認證服務器登錄',
            },
        },
        linkedin: {
            title: '通過LinkedIn登錄',
        },
        microsoft: {
            title: '通過Microsoft登录',
        },
        register_email: {
            /**
             *   email_placeholder: '请输入企业邮箱',
            password_placeholder: '请输入密码',
             */
            email_placeholder: '請輸入企業郵箱',
            password_placeholder: '請輸入密碼',
            password: {
                required: '請輸入密碼',
                invalid: '密碼必須是8-32個字符，且包含數字。',
            },
            email: {
                required: '請輸入郵箱',
                invalid: '請輸入有效的郵箱地址',
                personalEmail: '請輸入您的商務郵箱',
                exists: '郵箱地址已經存在。',
                inBlacklist: '請輸入您的商務郵箱',
            },
            server: {
                busy: '服務繁忙，請稍後再試。',
            },
        },
        google_login: {
            title: '通過谷歌登錄',
            error_code: {
                31620: '認證信息過期，請重試。',
                31621: '您的賬號還未認證，請到您的郵箱點擊激活。如未收到郵件，點擊<a class="login-with-google-error-target" data-code="30111" target="_blank" href="{ accountUrl }/public/?{ paramsUrl }#/resendActive?email={ userEmail }">這裡</a>.',
                30141: '賬號被禁用',
                30102: '賬號被禁用',
                30103: '用戶名密碼錯誤',
                30101: '用戶名密碼錯誤',
                30113: '用戶名密碼錯誤',
                180102: '用戶名密碼錯誤',
                30129: '郵箱已經存在。',
                30401: '您已登出，請重新登錄',
                30407: '會話已超時，請重新登錄',
                180203: '驗證碼錯誤',
                unknown: '發生未知錯誤，需要幫助請聯繫我們',
            },
        },
        confirm_password: {
            message: '您的郵箱: {email}',
            title: '驗證您的賬戶',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            inputPlaceholder: '輸入您的 PatSnap 賬戶密碼',
            inputErrorMessage: '密碼必須是8-32個字符，且包含數字。',
        },
        free_sign_up: '免費註冊',
    },
}
